<template>
	<div style="position: relative;">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-row >
			<b-col lg="3">
				<b-card>
					<h3 class="text-center">
						{{$t("zonedArea.zones") }}
						<b-button  @click="addZone" size="sm" variant="success" v-if="canEdited"
							><md-icon icon="add"
						/></b-button>
					</h3>
					<hr class="m-2"/>
					<draggable
						v-model="zones"
						group="people"
						class="list-group"
						ghost-class="ghost"
						@start="drag = true"
						@end="drag = false"
						@change="onChange"
					>
						<div
							v-for="(zone, i) in zones"
							:key="i"
							class="list-group-item"
							v-bind:class="{ listItemActive: isSelect(zone) }"
							@click="selectZone(zone)"
							style="border-radius: 5px;padding:5px"
						>
							<div class="zone-name draggable-item" >
								<b-form-input
								@click.stop="()=>{}"
								v-if="editingZoneNameIndex == i"
								type="text"
								v-model="zone.name"
								required/>
								<div v-else>{{ zone.name }}</div>
							</div>

							<div class="zone-priority">
								<small>{{ $t("zonedArea.priority") }}: {{ zone.priority }}</small>
							</div>

							<!-- Buttons edit -->
							<div class="button-actions" v-if="canEdited">
								<b-input-group class="input-groups">
									<template #append>
										<b-button v-if="editingZoneNameIndex === i" variant="secondary" @click.stop="editingZoneNameIndex=-1">
											<md-icon icon="close" />
										</b-button>
										<b-button
											@click.stop="toggleEditZoneName(i)"
											variant="success"
										>
											<md-icon
												v-if="editingZoneNameIndex != i"
												icon="edit"
											/>
											<md-icon v-else icon="save" />
										</b-button>

										<b-button
											:disabled="disableBtnDeleteZone"
											@click.stop="deleteZone(i)"
											variant="danger"
											><md-icon icon="delete"
										/></b-button>
									</template>
								</b-input-group>
							</div>
						</div>
					</draggable>
				</b-card>
			</b-col>
			<b-col lg class="map-container flex-grow-1">
				<b-card>
					<h2 class="text-center" v-if="editingZone">
						Editing Zone: {{ editingZone.name }}<br />
						<small
							class="text-danger"
							v-if="editingZone.polygon == null"
							>Click en el mapa para agregar puntos. Click en el primer punto (naranja) o doble click para cerrar.</small
						>
						<template v-if="canEdited">
							<b-button
								v-if="isDrawing && drawingPoints.length > 0"
								@click="cancelDrawing"
								variant="danger"
								size="sm"
								class="ml-2"
							>Cancelar dibujo</b-button>
							<b-button
								v-if="isDrawing && drawingPoints.length >= 3"
								@click="finishDrawing"
								variant="success"
								size="sm"
								class="ml-2"
							>Finalizar polígono</b-button>
						</template>
					</h2>
					<div class="text-center" v-if="enableSearchBox">
						<input id="search-box" type="text" ref="search-box" />
					</div>
					<div id="zones-map" ref="map"></div>
				</b-card>
			</b-col>
			<b-col lg="2" v-if="canEdited">
				<b-card>
					<b-button  @click="onSave" variant="success" size="lg" block
						><md-icon icon="save" /><br />{{ $t("global.save") }}</b-button
					>
					<hr/>
					<b-button
						@click="$emit('reFetch')"
						variant="warning"
						size="lg"
						block
						><md-icon icon="restore" /><br />{{ $t("zonedArea.restore") }}</b-button
					>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import draggable from "vuedraggable";
import * as turf from '@turf/turf';
export default {
	props: {
		zonedArea: {
			type: Object,
			required: true
		},
		mode:{
			type:String,
			required:false,
			default:""
		}
	},
	components: { draggable },
	data() {
		return {
			firstFetch: true,
			zones: [],
			loading: true,
			map: null,
			editingZone: null,
			editingZoneNameIndex: -1,
			hackUpdateCoords: 0,
			// Drawing state (reemplazo de DrawingManager deprecado en v3.65)
			isDrawing: false,
			drawingPoints: [],
			drawingMarkers: [],
			drawingPolyline: null,
			mapClickListener: null,
			mapDblClickListener: null,
			polygonEditableOpts: {
				drawingControl: true,
				strokeColor: "#3fb618",
				fillColor: "#3fb618",
				editable: true,
				draggable: true
			},
			polygonNotEditableOpts: {
				drawingControl: false,
				strokeColor: "#dc3545",
				fillColor: "#dc3545",
				editable: false,
				draggable: false
			},
			enableSearchBox:false
		};
	},
	computed: {
		canEdited(){
			if(this.mode=='readonly') return false;
			return true;
		},
		editingZonePoints(){
			this.hackUpdateCoords
			if (this.editingZone !== null) {
				return this.editingZone.polygon
					.getPath()
					.getArray()
					.map(path => ({
						latitude: path.lat(),
						longitude: path.lng()
					}))
			}
			return []
		},
		disableBtnDeleteZone(){
			return (this.editingZoneNameIndex>=0)
		}
	},
	methods: {
		onChange () {
			this.zones.forEach( (e, i) => {
				e.priority = 100 - i;
			});
		},
		isSelect(zone) {
			if (this.editingZone) {
				return this.editingZone.id === zone.id;
			}
			return false;
		},
		toggleEditZoneName(index) {
			if (this.editingZoneNameIndex === index) {
				this.onUpdateZoneName();
				this.editingZoneNameIndex = -1;
			} else {
				this.editingZoneNameIndex = index;
			}
		},
		onUpdateZoneName() {
			if (this.zones[this.editingZoneNameIndex].infoWindow) {
				let content = this.getContentInfoWindow(this.zones[this.editingZoneNameIndex].name);
				this.zones[this.editingZoneNameIndex].infoWindow.setOptions({
					content
				});
			}
			this.editingZoneNameIndex = -1;
		},
		addZone() {
			this.zones.push({
				id: -1,
				name: `ZONE ${this.zones.length + 1}`,
				polygon: null,
				infoWindow: null,
				priority: 100 - this.zones.length
			});
			this.selectZone(this.zones[this.zones.length - 1]);
		},
		deleteZone(index) {
			this.stopDrawing();
			if (this.zones[index].id == -1) {
				if (this.zones[index].polygon)
					this.zones[index].polygon.setMap(null);
				if (this.zones[index].infoWindow)
					this.zones[index].infoWindow.close();

				this.zones.splice(index, 1);
			} else {
				this.$root.showWarning({
					message:this.$t("zonedArea.confirmDeleteZone"),
					okAction: (_event, setLoading, close) => {
						setLoading(true);
						this.$root.api
							.delete(`/zoned-areas/${this.zonedArea.id}/zones/${this.zones[index].id}`)
							.then(() => {
								this.$root.showAlert("Zona eliminada!", {
									variant: "warning"
								});
								if (this.zones[index].polygon)
									this.zones[index].polygon.setMap(null);
								if (this.zones[index].infoWindow)
									this.zones[index].infoWindow.close();
								this.zones.splice(index, 1);
								close();
							})
							.catch(err => {
								this.$root.handleRequestError(err);
								close();
							});
					}
				});
			}
		},
		selectZone(zone) {
			this.stopDrawing();
			this.editingZone = zone;
			this.blockPolygons();
			this.closeAllInfoWindows();
			if (this.editingZone.polygon == null) {
				if (this.canEdited) this.startDrawing();
			} else {
				this.editingZone.polygon.setOptions(this.polygonEditableOpts);
				this.focusPolygonInMap(zone);
				setTimeout(() => {
					zone.infoWindow.open(this.map);
				}, 300);
			}
		},
		focusPolygonInMap(){
			let bounds = new window.google.maps.LatLngBounds();
			this.editingZone.polygon.getPath().forEach(function(latLng) {
				bounds.extend(latLng);
			});
			this.map.fitBounds(bounds);
		},
		closeAllInfoWindows(){
			this.zones.forEach(zone => {
				if (zone.infoWindow) {
					zone.infoWindow.close(null);
				}
			});
		},
		blockPolygons() {
			this.zones.forEach(zone => {
				if (zone.polygon) {
					zone.polygon.setOptions(this.polygonNotEditableOpts);
				}
			});
		},
		getCentroid(polygon) {
			let PI = 22 / 7;
			let X = 0;
			let Y = 0;
			let Z = 0;
			polygon.getPath().forEach(function(vertex) {
				let lat1 = vertex.lat();
				let lon1 = vertex.lng();
				lat1 = (lat1 * PI) / 180;
				lon1 = (lon1 * PI) / 180;
				X += Math.cos(lat1) * Math.cos(lon1);
				Y += Math.cos(lat1) * Math.sin(lon1);
				Z += Math.sin(lat1);
			});
			let Lon = Math.atan2(Y, X);
			let Hyp = Math.sqrt(X * X + Y * Y);
			let Lat = Math.atan2(Z, Hyp);
			Lat = (Lat * 180) / PI;
			Lon = (Lon * 180) / PI;
			return new window.google.maps.LatLng(Lat, Lon);
		},
		initZones(zones) {
			let priority = 100;
			this.zones = zones.map(zone => {
				let polygon = this.createPolygon(zone.zoneGeoPoints);
				let infoWindow = this.createInfoWindow(zone.name, polygon);
				let auxZone = {
					id: zone.id,
					name: zone.name,
					priority: priority,
					polygon,
					infoWindow
				};
				priority = priority - 1;
				this.setZonePolygonEvents(auxZone);
				return auxZone;
			});
		},
		createPolygon(geoPoints) {
			let polygone = new window.google.maps.Polygon({
				paths: geoPoints.map(gp => ({
					lat: parseFloat(gp.latitude),
					lng: parseFloat(gp.longitude)
				})),
				...this.polygonNotEditableOpts
			});
			polygone.setMap(this.map);
			return polygone;
		},
		setZonePolygonEvents(zone) {
			zone.polygon.addListener("mouseup", () => {
				this.hackUpdateCoords++;
			});
			zone.polygon.addListener("drag", () => {
				zone.infoWindow.close();
			});
			zone.polygon.addListener("dragend", () => {
				zone.infoWindow.setOptions({
					position: this.getCentroid(zone.polygon)
				});
			});
			zone.polygon.addListener("dblclick", event => {
				event.stop();
				this.selectZone(zone);
			});
			zone.polygon.addListener("rightclick", event => {
				if (event.vertex == undefined) return;
				zone.polygon.getPath().removeAt(event.vertex);
			});
		},
		// Métodos de dibujo manual (reemplazo de DrawingManager deprecado en v3.65)
		startDrawing() {
			this.isDrawing = true;
			this.drawingPoints = [];
			this.clearDrawingElements();

			this.mapClickListener = this.map.addListener("click", (event) => {
				if (!this.isDrawing) return;

				const latLng = event.latLng;
				const isFirst = this.drawingPoints.length === 0;
				this.drawingPoints.push(latLng);

				const marker = new window.google.maps.Marker({
					position: latLng,
					map: this.map,
					icon: {
						path: window.google.maps.SymbolPath.CIRCLE,
						scale: 6,
						fillColor: isFirst ? "#ff8800" : "#3fb618",
						fillOpacity: 1,
						strokeColor: "#ffffff",
						strokeWeight: 2
					}
				});

				// El primer punto cierra el polígono al clickearlo (si hay 3+ puntos)
				if (isFirst) {
					marker.addListener("click", () => {
						if (this.drawingPoints.length >= 3) {
							this.finishDrawing();
						}
					});
				}

				this.drawingMarkers.push(marker);
				this.updateDrawingPolyline();
			});

			this.mapDblClickListener = this.map.addListener("dblclick", () => {
				if (this.isDrawing && this.drawingPoints.length >= 3) {
					this.finishDrawing();
				}
			});
		},
		updateDrawingPolyline() {
			if (this.drawingPolyline) {
				this.drawingPolyline.setMap(null);
			}
			if (this.drawingPoints.length > 1) {
				this.drawingPolyline = new window.google.maps.Polyline({
					path: this.drawingPoints,
					strokeColor: "#3fb618",
					strokeOpacity: 0.8,
					strokeWeight: 2,
					map: this.map
				});
			}
		},
		finishDrawing() {
			if (this.drawingPoints.length < 3) return;

			const polygon = new window.google.maps.Polygon({
				paths: this.drawingPoints,
				...this.polygonEditableOpts
			});
			polygon.setMap(this.map);

			const infoWindow = this.createInfoWindow(this.editingZone.name, polygon);
			this.editingZone.polygon = polygon;
			this.editingZone.infoWindow = infoWindow;
			this.setZonePolygonEvents(this.editingZone);

			this.stopDrawing();
		},
		cancelDrawing() {
			this.clearDrawingElements();
			this.stopDrawing();
		},
		stopDrawing() {
			this.isDrawing = false;
			this.drawingPoints = [];
			this.clearDrawingElements();

			if (this.mapClickListener) {
				window.google.maps.event.removeListener(this.mapClickListener);
				this.mapClickListener = null;
			}
			if (this.mapDblClickListener) {
				window.google.maps.event.removeListener(this.mapDblClickListener);
				this.mapDblClickListener = null;
			}
		},
		clearDrawingElements() {
			this.drawingMarkers.forEach(marker => marker.setMap(null));
			this.drawingMarkers = [];

			if (this.drawingPolyline) {
				this.drawingPolyline.setMap(null);
				this.drawingPolyline = null;
			}
		},
		getContentInfoWindow(zoneName){
			const contentString = `
			<div style='max-width:10rem;padding:.5rem' id='${zoneName}'>
				<h5 id="firstHeading">${zoneName}</h5>
				<div id="bodyContent">
				</div>
			</div>`;
			return contentString;
		},
		createInfoWindow(zoneName, polygon) {
			let content = this.getContentInfoWindow(zoneName);
			return new window.google.maps.InfoWindow({
				content: content,
				position: this.getCentroid(polygon)
			});
		},
		initMap() {
			this.map = new window.google.maps.Map(this.$refs["map"], {
				center: { lat: 21.1214886, lng: -86.9192742 },
				zoom: 8,
				streetViewControl: false
			});

			if(this.enableSearchBox){
				this.initSearchBox();
			}
		},
		initSearchBox(){
			let searchBox = new window.google.maps.places.SearchBox(
				this.$refs["search-box"]
			);
			this.map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(
				this.$refs["search-box"]
			);
			this.map.addListener("bounds_changed", () => {
				searchBox.setBounds(this.map.getBounds());
			});
			let markers = [];
			searchBox.addListener("places_changed", () => {
				let places = searchBox.getPlaces();

				if (places.length == 0) {
					return;
				}
				markers.forEach((marker) => {
					marker.setMap(null);
				});
				markers = [];

				var bounds = new window.google.maps.LatLngBounds();
				places.forEach(place => {
					if (!place.geometry) {
						console.log("Returned place contains no geometry");
						return;
					}
					if (place.geometry.viewport) {
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				this.map.fitBounds(bounds);
			});
		},
		loadZonedArea() {
			this.loading = true;
			this.resetMap();
			this.initZones(this.zonedArea.zones);
			if (this.firstFetch && this.zones.length > 0) {
				this.map.setCenter(this.getCentroid(this.zones[0].polygon));
				this.firstFetch = false;
			}
			this.loading = false;
		},
		resetMap() {
			this.editingZone = null;
			this.zones.forEach(zone => {
				if (zone.polygon) {
					zone.polygon.setOptions(this.polygonNotEditableOpts);
					zone.polygon.setMap(null);
				}
				if (zone.infoWindow) zone.infoWindow.close();
			});
		},
		onSave() {
			let query = {
				zones: this.zones
					.filter(zone => zone.polygon != null)
					.map(zone => {
						return {
							id: zone.id,
							name: zone.name,
							priority: zone.priority,
							geoPoints: zone.polygon
								.getPath()
								.getArray()
								.map(path => ({
									latitude: path.lat(),
									longitude: path.lng()
								}))
						};
					})
			};
			if (!this.validatePolygons()) return;
			this.$root.api
				.put(`/zoned-areas/${this.zonedArea.id}/zones`, query)
				.then(() => {
					this.$root.showAlert("Actualización exitosa");
					this.$emit("reFetch");
				})
				.catch(this.$root.handleRequestError);
		},
		validatePolygons(){
			let errorFound = false;
			this.zones.forEach(zone => {
				if (zone.polygon && !errorFound) {
					const polygon = zone.polygon;
					const paths = polygon.getPaths().getArray().map(path => path.getArray().map(latlng => [latlng.lng(), latlng.lat()]));
					const polygonGeoJSON = {
						type: "Feature",
						geometry: {
							type: "Polygon",
							coordinates: paths
						}
					};
					if (turf.kinks(polygonGeoJSON).features.length > 0) {
						alert("The polygon "+zone.name+" has self-intersections. Please draw a valid polygon.");
						this.selectZone(zone);
						errorFound = true;
					}
				}
			});
			return !errorFound;
		}
	},
	mounted() {
		this.initMap();
		this.loadZonedArea();
	},
	watch: {
		zonedArea: function() {
			this.loadZonedArea();
			this.stopDrawing();
		}
	}
};
</script>

<style scoped>
h2 {
	min-height: 40px;
}
#search-box {
	width: 100%;
	max-width: 400px;
	padding: 5px;
	font-size: 16px;
}
.zone-button {
	flex: 1;
}
.input-groups {
	width: 100%;
}
.list-group-item {
	color: #fff;
	background-color: #007bff;
	border-color: #007bff;
	margin-bottom: 5px;
	padding-right: 0;
	padding-top: 0;
	padding-bottom: 0;
	cursor: pointer;
}

.listItemActive {
	color: #212529;
	background-color: #ffc107;
	border-color: #ffc107;
	clear: both;
}

.button-actions {
	float: right;
}

.zone-name{
	margin-top: 5px;
	padding-bottom: 5px;
	padding-right: 12.8px;
}

.zone-priority {
	float: left;
	margin-top: 5px;
}

</style>
<style scoped>
#zones-map {
	width: 100%;
	height: 500px;
}
.col,.col-3,.col-2,.col-7{
	padding-left: 10px;
	padding-right: 10px;
}

.map-container .card-body{
	padding: 0rem;
}
.draggable-item {
  cursor: move !important;
}
</style>
